import React, { Component } from 'react'
import { connect } from 'react-redux'
import Auth from './Auth'
import Navigator from './Navigator'
import Login from './Login'
import { Route, withRouter} from 'react-router-dom'

import './Main.css'

class Main extends Component {

  render() {
    return (
      <div>
        <Navigator />
        <Route exact path="/login" component={Login} />
        <Auth/>

      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    ...state
  }
}

export default withRouter(
    connect(mapStateToProps)(Main)
);



// WEBPACK FOOTER //
// ./src/containers/Main.js